import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=4e2b7747&"
import script from "./message-item.vue?vue&type=script&lang=js&"
export * from "./message-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports